<template>
  <BaseSelectMultiple
    v-model="internalModel"
    :options="options"
  >
    <template #button>
      <button
        type="button"
        class="border-1 border-background-fg/8 block flex w-full items-center justify-between rounded-full p-1 py-1 shadow-sm"
        :class="[
          props.modelValue?.length
            ? 'bg-primary text-white'
            : 'bg-background',
          'disabled:opacity-70',
        ]"
        :disabled="isDisabled"
      >
        <span
          :class="[
            props.modelValue?.length
              ? ''
              : 'text-background-fg/70',
            'mx-2 line-clamp-1 text-xs font-medium',
          ]"
        >
          <template v-if="selectedOptionsLabel">
            {{ selectedOptionsLabel }}
          </template>
          <template v-else>
            {{ props.label }}
          </template>
        </span>
        <IconHeroiconsSolidChevronDown
          class="bg-background-fg/10 rounded-full"
        />
      </button>
    </template>
  </BaseSelectMultiple>
</template>

<script
  setup
  lang="ts"
  generic="
    TValue extends string | number | undefined | null
  "
>
import type { Option } from "@/composables/options/options"

const props = withDefaults(
  defineProps<{
    modelValue: (TValue | undefined)[] | undefined
    options: Option<TValue>[]
    label: string
    isDisabled?: boolean
  }>(),
  {
    isDisabled: false,
  }
)
const emit = defineEmits<{
  (
    event: "update:modelValue",
    params: typeof props.modelValue
  ): void
}>()

const internalModel = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit("update:modelValue", value)
  },
})

const selectedOptionsLabel = computed(() =>
  props.modelValue
    ?.map(
      (selectedValue) =>
        props.options.find(
          ({ value }) => value === selectedValue
        )?.label
    )
    .join(", ")
)
</script>
